export interface TsPdfUrlRequest {
    ts_code: string;
    version: string;
}

export interface TsPdfUrlResponse {
    status: boolean;
    error_code: number;
    error_msg?: string;
    data?: {
        ts_code: string;
        version: string;
        url: string;
    };
}

export const TsPdfUrlApi = Symbol('TsPdfUrlApi');

export interface TsPdfUrlApi {
    getPdfUrl(request: TsPdfUrlRequest): Promise<TsPdfUrlResponse>;
}
